import React from 'react';
import { Link } from 'react-router-dom';
import EditIcon from '../../icons/EditIcon';
import AccountInfoItem from './AccountInfoItem';
import InputErrors from '../../common/InputErrors';
import LoadingButton from '../../common/LoadingButton';

function InstitutionCard({ institution, toggleEdit, isEditing, handleChange, temporaryValues, cancelEdits, saveEdits, errors, loadingInstitutionEdits }) {
  return (
    <div className="account__card">
      <h2 className="account__subheading">
        Institution Information
      </h2>
      {errors.length !== 0 && <InputErrors errors={errors} />}
      <button
        type="button"
        className="flat-link-from-button account__edit-card-button"
        onClick={toggleEdit}
        disabled={isEditing}
      >
        <EditIcon disabled={isEditing} />
      </button>
      <AccountInfoItem
        label="Institution Name"
        value={institution.name}
        name="name"
        itemType="institution"
        isEditing={isEditing}
        handleInputChange={handleChange}
        temporaryValue={temporaryValues.institution.name}
      />
      <AccountInfoItem
        label="Unit Location"
        name="location"
        value={institution.location}
        itemType="institution"
        isEditing={isEditing}
        handleInputChange={handleChange}
        temporaryValue={temporaryValues.institution.location}
      />
      {isEditing && (
        <div className="account__edit-buttons-wrapper">
          <button
            type="button"
            className="button button--reversed button--small"
            onClick={cancelEdits}
          >
            Cancel
          </button>
          <LoadingButton
            text="Save Changes"
            onClick={saveEdits}
            loading={loadingInstitutionEdits}
            largeButton={false}
          />
        </div>
      )}
      <div className="account__info-item">
        <div className="account__info-label">
          Manage Users
        </div>
        <div>
          <Link to="/account/users" className="flat-link account__edit-item-button">
            <EditIcon />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default InstitutionCard;



// WEBPACK FOOTER //
// ./src/components/features/account/InstitutionCard.js